/**
 * Responsible for defining local storage keys.
 */
export const STORAGE_KEYS = {

  localUser: "localUser",
  cart: "cart"
}
